const cache = new Map();
let dictionaryWordSet = null;
let dictionaryWordSetPromise = null;

const normalizeWord = (word) => String(word || '').trim().toUpperCase();
const isSimpleAlphaWord = (word) => /^[A-Z]+$/.test(word);

const loadDictionaryWordSet = async () => {
  if (dictionaryWordSet) {
    return dictionaryWordSet;
  }

  if (!dictionaryWordSetPromise) {
    dictionaryWordSetPromise = import('word-list-json')
      .then((module) => {
        const words = Array.isArray(module?.default) ? module.default : [];
        dictionaryWordSet = new Set(words.map((word) => String(word || '').toUpperCase()));
        return dictionaryWordSet;
      })
      .catch((error) => {
        dictionaryWordSetPromise = null;
        throw error;
      });
  }

  return dictionaryWordSetPromise;
};

export const preloadDictionary = () => {
  void loadDictionaryWordSet();
};

export const isDictionaryWord = async (word) => {
  const normalized = normalizeWord(word);
  if (!normalized || !isSimpleAlphaWord(normalized)) {
    return false;
  }

  if (cache.has(normalized)) {
    return cache.get(normalized);
  }

  const activeDictionary = await loadDictionaryWordSet();
  const isValid = activeDictionary.has(normalized);

  cache.set(normalized, isValid);
  return isValid;
};

export const validateWords = async (words) => {
  const unique = [...new Set(words.map(normalizeWord).filter(Boolean))];
  const result = {};

  await Promise.all(
    unique.map(async (word) => {
      result[word] = await isDictionaryWord(word);
    })
  );

  return result;
};

export const clearDictionaryCache = () => {
  cache.clear();
};